<template>
  <div
    class="w-16 md:w-52 top-20 md:sticky md:block hidden"
    ref="sideMenu"
    style="min-width: 4rem"
    v-if="groups.length > 0"
  >
    <div
      id="groups-list"
      ref="sideMenuAbsolute"
      class="
        z-40
        w-16
        md:w-52
        hover:w-52
        bg-white
        rounded-xl
        shadow-allArround
        md:py-1
        py-4
        transition-all
        ease-out
      "
    >
      <div
        v-for="(group, index) in groups"
        v-bind:key="index"
        class="
          mt-2
          w-full
          h-10
          relative
          font-bold
          flex
          items-center
          cursor-pointer
          group
          transition-all
          duration-300
          ease-out
          focus:outline-none
        "
        v-on:click="setCurrentGroup(index)"
        :class="
          index == selectedGroup
            ? 'text-primary-color hover:bg-primary-100 focus:bg-primary-100'
            : 'text-gray-600 hover:text-gray-800 focus:text-gray-800 hover:bg-gray-100 focus:bg-gray-100'
        "
      >
        <div
          class="
            absolute
            left-0
            w-0.5
            transition-all
            duration-300
            ease-out
            rounded-full
          "
          :class="
            index == selectedGroup
              ? 'bg-primary-color h-full'
              : 'group-hover:bg-gray-300 h-full group-hover:h-full'
          "
        ></div>
        <div class="flex ml-5">
          <div class="w-44 md:block transition-all duration-300 ease-out">
            {{ group.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["groupsValues"],
  components: {},
  data() {
    return {
      groups: [],
      selectedGroup: 0,
      headerOffset: 0,
    };
  },
  methods: {
    setCurrentGroup(index) {
      this.selectedGroup = index;
      this.scrollToTargetAdjusted(index);
    },

    onScroll(e) {
      this.windowTop = e.target.documentElement.scrollTop + this.headerOffset;

      if (!this.groupsValues) {
        return;
      }

      for (let i = 0; i < this.groupsValues.length; i++) {
        if (
          this.windowTop >= this.groupsValues[i] &&
          this.windowTop < this.groupsValues[i + 1]
        ) {
          this.selectedGroup = i;
        }
      }
    },

    scrollToTargetAdjusted(id) {
      var element = document.getElementById(`group-${id}`);

      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition =
        elementPosition + window.pageYOffset - this.headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
  },

  created() {},
  mounted() {
    this.headerOffset = document.getElementById("header").offsetHeight + 5;

    this.axios.get("groups").then((response) => {
      if (response.data) {
        this.groups = response.data;
      }
    });

    window.addEventListener("scroll", this.onScroll);
  },

  beforeDestroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>